import {Component, OnInit, ViewChild} from '@angular/core';

import {ModalConfirmationComponent} from 'shared/modals/modal-confirmation/modal-confirmation.component';
import {Category} from 'shared/models/target-groups/category';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';
import {CategoriesService} from './services/categories.service';

@Component({
  selector: 'categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css'],
})

export class CategoriesComponent implements OnInit {
  public allCategories: Array<Category> = [];
  public filteredCategories: Array<Category>;
  public fieldsToSearch: Array<Array<String>> = [];
  public newCategoryName: String;
  public currentPage: Event;
  @ViewChild('deleteModal') private deleteModal: ModalConfirmationComponent;

  constructor(private categoriesService: CategoriesService) { }

  public ngOnInit(): void {
    this.getAllCategories();
  }

  private showDeleteModal(id: number): void {
    const content: string = `Sind Sie wirklich sicher, dass Sie diese Kategorie löschen möchten?`;

    this.deleteModal.setContent(content)
      .setEventData(id)
      .show();
  }

  public getAllCategories(): void {
    this.categoriesService.getAllCategories()
      .subscribe((allCategories: Array<Category>) => {
        this.allCategories = allCategories;
        this.filteredCategories = allCategories;
        this.prepareFieldsToSearch();
      });
  }

  public createCategory(): void {
    this.categoriesService.createCategory(this.newCategoryName)
      .subscribe((createdCategory: Category) => {
        this.getAllCategories();
      });
  }

  public updateCategory(category: Category): void {
    this.categoriesService.updateCategory(category)
      .subscribe((updatedCategory: Category) => {
        this.getAllCategories();
      });
  }

  public deleteCategory(category: Category): void {
    this.categoriesService.deleteCategory(category)
      .subscribe((response: boolean) => {
        this.getAllCategories();
      });
  }

  public filterCategories(eventCategories: Array<Category>): void {
    this.filteredCategories = eventCategories;
  }

  private prepareFieldsToSearch(): void {
    this.allCategories.forEach((category: Category) => {
      this.fieldsToSearch.push([
        category.name.toLowerCase(),
      ]);
    });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/categories/categories.component.ts